import { UserRole } from '@/enums/user'
import i18n from '@/libs/i18n'
import type { SelectOption, TagItem } from '@/types/Common'

/** What the role is called in the reader's own language. */
export const roleLabel = (role: string): string =>
    role === UserRole.Admin ? i18n.global.t('user.role_admin') : i18n.global.t('user.role_reader')

/*
 * The badge in the user table.
 *
 * Only the administrator carries a colour: it is the row that can change what
 * everybody else sees, and it should be the one the eye finds when somebody scans the
 * list asking who has the keys. A reader is the ordinary case and stays neutral.
 */
export const getRoleTag = (role: string): TagItem => role === UserRole.Admin
    ? { label: roleLabel(role), color: 'primary' }
    : { label: roleLabel(role), color: 'neutral' }

/** The two roles, for the select in the user dialog. */
export const roleOptions = (): SelectOption[] => [
    { label: roleLabel(UserRole.Admin),  value: UserRole.Admin },
    { label: roleLabel(UserRole.Reader), value: UserRole.Reader },
]
